import React from "react";
import { ImageWithInformation } from "@aph/ui-lib-humanx";
import { useRouter } from "next/navigation";
import { BannerInfo } from "@/components/PageHome/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import { assetClickedEvent } from "@/helpers/TSDEvents";
import { getPlainTexts } from "@/helpers";
import { NON_ONBOARDED_STATUS, ONBOARDING_STATUS } from "@/helpers/constants";
import SegmentInfoSelector from "@/redux/slice/auth/selectors/userSegmentInfo";
import { useAppSelector } from "@/redux/hooks";
import styles from "./Banner.module.scss";

interface BannerProps {
  data: BannerInfo;
  userAgent: DeviceInfo;
  assetPosition?: number;
}

const Banner: React.FC<BannerProps> = ({ data, userAgent, assetPosition }) => {
  const { Title, Description, Image, CTAText, CTAUrl, ImageOpacity } = data;
  const router = useRouter();
  const SegmentInfoObject = useAppSelector(SegmentInfoSelector);

  return (
    <div className={styles.root}>
      <ImageWithInformation
        imageUrl={Image?.data?.attributes?.url}
        rawSubTitle={Description}
        rawTitle={Title}
        onClick={() => {
          assetClickedEvent({
            asset_name: "Apollo Ayurvedic Care Banner",
            asset_display_text: getPlainTexts(Title),
            asset_position: assetPosition,
            momverse_stage: SegmentInfoObject?.type
              ? (ONBOARDING_STATUS[SegmentInfoObject?.type] ?? "")
              : NON_ONBOARDED_STATUS,
          });

          if (CTAUrl) {
            router.push(CTAUrl);
          }
        }}
        redirectUrl={CTAUrl}
        ctaText={CTAText}
        isAyurvedic
        wrapperHeight={userAgent?.isMobile ? "278px" : "372px"}
        contentClassName={`container ${styles.ayurvedaBanner}`}
        isImageCover
        overlayOpacity={`${ImageOpacity}`}
      />
    </div>
  );
};

export default Banner;
